import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PositionTooltipType } from './awesome-tooltip-v2.directive';

interface PatientSignerSavedTooltip {
  relationshipTitle?: string | null;
  relationshipToRecipient?: string | null;
  fullName?: string | null;
  reason?: string | null;
}

@Component({
  selector: 'app-awesome-tooltip-v2',
  templateUrl: './awesome-tooltip-v2.component.html',
  styleUrls: ['./awesome-tooltip-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AwesomeTooltipV2Component {
  @Input() patientSignerSaved: PatientSignerSavedTooltip | null = null;
  @Input() tooltipText = '';
  @Input() positionTooltip: PositionTooltipType = 'topCenter';
  @Input() customClass: string = '';
  @Input() textAlign: 'center' | 'left' = 'center';
  @Input() actions: boolean = false;
  @Input() insideTable: boolean = false;

  get relationshipTooltipText(): string {
    return [this.patientSignerSaved?.relationshipTitle, this.patientSignerSaved?.relationshipToRecipient].filter(Boolean).join('; ');
  }
}
